import analytics from '../lib/analytics';

const OPEN_MODAL = 'scratch-gui/modals/OPEN_MODAL';
const CLOSE_MODAL = 'scratch-gui/modals/CLOSE_MODAL';

const MODAL_BACKDROP_LIBRARY = 'backdropLibrary';
const MODAL_CAMERA_CAPTURE = 'cameraCapture';
const MODAL_COSTUME_LIBRARY = 'costumeLibrary';
const MODAL_EXTENSION_LIBRARY = 'extensionLibrary';
const MODAL_IMPORT_INFO = 'importInfo';
const MODAL_LOADING_PROJECT = 'loadingProject';
const MODAL_PREVIEW_INFO = 'previewInfo';
const MODAL_SOUND_LIBRARY = 'soundLibrary';
const MODAL_SPRITE_LIBRARY = 'spriteLibrary';
const MODAL_SOUND_RECORDER = 'soundRecorder';
const MODAL_CONNECTION = 'connectionModal';
const MODAL_TIPS_LIBRARY = 'tipsLibrary';
// 串口连接
const MODAL_SERIAL_CONNECTION = 'serialConnectionModal';
// 固件升级模态框
const MODAL_FIRMWARE = 'firmware';
// 正在更新
const MODAL_UPLOADING = 'uploading';
// 更新出错
const MODAL_UPLOAD_FAILURE = 'uploadFailure';
// 更新成功
const MODAL_UPLOAD_SUCCESS = 'uploadSuccess';
// 用户登录注册弹窗
const MODAL_ACCOUNT = 'accountModal';

const MODAL_UPLOAD_TYPE = 'uploadModalType';

const initialState = {
    [MODAL_BACKDROP_LIBRARY]: false,
    [MODAL_CAMERA_CAPTURE]: false,
    [MODAL_COSTUME_LIBRARY]: false,
    [MODAL_EXTENSION_LIBRARY]: false,
    [MODAL_IMPORT_INFO]: false,
    [MODAL_LOADING_PROJECT]: false,
    [MODAL_PREVIEW_INFO]: false,
    [MODAL_SOUND_LIBRARY]: false,
    [MODAL_SPRITE_LIBRARY]: false,
    [MODAL_SOUND_RECORDER]: false,
    [MODAL_CONNECTION]: false,
    [MODAL_TIPS_LIBRARY]: false,
    // 串口连接
    [MODAL_SERIAL_CONNECTION]: false,
    // 固件升级模态框
    [MODAL_FIRMWARE]: false,
    // 正在更新
    [MODAL_UPLOADING]: false,
    // 更新出错
    [MODAL_UPLOAD_FAILURE]: false,
    // 更新成功
    [MODAL_UPLOAD_SUCCESS]: false,
    // 用户登录注册模态框
    [MODAL_ACCOUNT]: false,
    [MODAL_UPLOAD_TYPE]: ''
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case OPEN_MODAL:
        return Object.assign({}, state, {
            [action.modal]: true
        });
    case CLOSE_MODAL:
        return Object.assign({}, state, {
            [action.modal]: false,
            uploadModalType: ''
        });
    case MODAL_UPLOAD_TYPE:
        return Object.assign({}, state, {
            uploadModalType: action.uploadModalType
        });
    default:
        return state;
    }
};
const openModal = function (modal) {
    return {
        type: OPEN_MODAL,
        modal: modal
    };
};
const closeModal = function (modal) {
    return {
        type: CLOSE_MODAL,
        modal: modal
    };
};

const updateModalUploadType = function (type) {
    return {
        type: MODAL_UPLOAD_TYPE,
        uploadModalType: type
    };
};


const openBackdropLibrary = function () {
    analytics.pageview('/libraries/backdrops');
    return openModal(MODAL_BACKDROP_LIBRARY);
};
const openCameraCapture = function () {
    analytics.pageview('/modals/camera');
    return openModal(MODAL_CAMERA_CAPTURE);
};
const openCostumeLibrary = function () {
    analytics.pageview('/libraries/costumes');
    return openModal(MODAL_COSTUME_LIBRARY);
};
const openExtensionLibrary = function () {
    analytics.pageview('/libraries/extensions');
    return openModal(MODAL_EXTENSION_LIBRARY);
};
const openImportInfo = function () {
    analytics.pageview('modals/import');
    return openModal(MODAL_IMPORT_INFO);
};
const openLoadingProject = function () {
    analytics.pageview('modals/loading');
    return openModal(MODAL_LOADING_PROJECT);
};
const openPreviewInfo = function () {
    analytics.pageview('/modals/preview');
    return openModal(MODAL_PREVIEW_INFO);
};
const openSoundLibrary = function () {
    analytics.pageview('/libraries/sounds');
    return openModal(MODAL_SOUND_LIBRARY);
};
const openSpriteLibrary = function () {
    analytics.pageview('/libraries/sprites');
    return openModal(MODAL_SPRITE_LIBRARY);
};
const openSoundRecorder = function () {
    analytics.pageview('/modals/microphone');
    return openModal(MODAL_SOUND_RECORDER);
};
const openConnectionModal = function () {
    analytics.pageview('/modals/connection');
    return openModal(MODAL_CONNECTION);
};
const openTipsLibrary = function () {
    analytics.pageview('/modals/tips');
    return openModal(MODAL_TIPS_LIBRARY);
};
const closeBackdropLibrary = function () {
    return closeModal(MODAL_BACKDROP_LIBRARY);
};
const closeCameraCapture = function () {
    return closeModal(MODAL_CAMERA_CAPTURE);
};
const closeCostumeLibrary = function () {
    return closeModal(MODAL_COSTUME_LIBRARY);
};
const closeExtensionLibrary = function () {
    return closeModal(MODAL_EXTENSION_LIBRARY);
};
const closeImportInfo = function () {
    return closeModal(MODAL_IMPORT_INFO);
};
const closeLoadingProject = function () {
    return closeModal(MODAL_LOADING_PROJECT);
};
const closePreviewInfo = function () {
    return closeModal(MODAL_PREVIEW_INFO);
};
const closeSpriteLibrary = function () {
    return closeModal(MODAL_SPRITE_LIBRARY);
};
const closeSoundLibrary = function () {
    return closeModal(MODAL_SOUND_LIBRARY);
};
const closeSoundRecorder = function () {
    return closeModal(MODAL_SOUND_RECORDER);
};
const closeTipsLibrary = function () {
    return closeModal(MODAL_TIPS_LIBRARY);
};
const closeConnectionModal = function () {
    return closeModal(MODAL_CONNECTION);
};
// 打开串口连接模态框
const openSerialConnectionModal = function () {
    analytics.pageview('/modals/serial-connection');
    return openModal(MODAL_SERIAL_CONNECTION);
};
// 关闭串口连接模态框
const closeSerialConnectionModal = function () {
    return closeModal(MODAL_SERIAL_CONNECTION);
};
// 打开固件升级模态框
const openFirmware = function () {
    return openModal(MODAL_FIRMWARE);
};
// 关闭固件升级模态框
const closeFirmware = function () {
    return closeModal(MODAL_FIRMWARE);
};
// 打开 正在更新
const openUploading = function () {
    return openModal(MODAL_UPLOADING);
};
// 关闭 正在更新
const closeUploading = function () {
    return closeModal(MODAL_UPLOADING);
};
// 打开 更新出错
const openUploadFailure = function () {
    return openModal(MODAL_UPLOAD_FAILURE);
};
// 关闭 更新出错
const closeUploadFailure = function () {
    return closeModal(MODAL_UPLOAD_FAILURE);
};
// 打开 更新成功
const openUploadSuccess = function () {
    return openModal(MODAL_UPLOAD_SUCCESS);
};
// 关闭 更新成功
const closeUploadSuccess = function () {
    return closeModal(MODAL_UPLOAD_SUCCESS);
};
// 打开 用户登录注册模态框
const openAccountModal = function () {
    return openModal(MODAL_ACCOUNT);
};
// 关闭 用户登录注册模态框
const closeAccountModal = function () {
    return closeModal(MODAL_ACCOUNT);
};

export {
    reducer as default,
    initialState as modalsInitialState,
    openAccountModal,
    openBackdropLibrary,
    openCameraCapture,
    openCostumeLibrary,
    openExtensionLibrary,
    openImportInfo,
    openLoadingProject,
    openPreviewInfo,
    openSoundLibrary,
    openSpriteLibrary,
    openSoundRecorder,
    openTipsLibrary,
    openConnectionModal,
    closeAccountModal,
    closeBackdropLibrary,
    closeCameraCapture,
    closeCostumeLibrary,
    closeExtensionLibrary,
    closeImportInfo,
    closeLoadingProject,
    closePreviewInfo,
    closeSpriteLibrary,
    closeSoundLibrary,
    closeSoundRecorder,
    closeTipsLibrary,
    closeConnectionModal,
    openSerialConnectionModal,
    closeSerialConnectionModal,
    openFirmware,
    closeFirmware,
    openUploading,
    closeUploading,
    openUploadFailure,
    closeUploadFailure,
    openUploadSuccess,
    closeUploadSuccess,
    updateModalUploadType
};
